//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data: function () {
    return {
      templates: []
    }
  },

  mounted: async function () {
    this.getTemplates();
  },

  methods: {
    getTemplates: async function () {
      const res = await this.$api.agent.transport.get('/template').then((res) => {
        return res.data
      }).catch(() => {
        return []
      });
      this.templates = res;
    },
  }
}
